import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../styles/icons/logo.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: '#FFFFFF',
    className: null,
};

const Close = ({ color, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="30px"
        height="30px"
        viewBox="0 0 30 30"
        xmlSpace="preserve"
        className={classNames([styles.container, { [className]: className !== null }])}
    >
        <g>
            <circle cx="15" cy="15" r="14.5" />
            <path
                fill={color}
                d="M15,1c7.72,0,14,6.28,14,14s-6.28,14-14,14S1,22.72,1,15S7.28,1,15,1 M15,0C6.72,0,0,6.72,0,15s6.72,15,15,15
		s15-6.72,15-15S23.28,0,15,0L15,0z"
            />
        </g>
        <polygon
            fill={color}
            points="22,9.73 20.26,8 15,13.26 9.73,8 8,9.73 13.26,15 8,20.26 9.73,22 15,16.73 20.26,22 22,20.26
	16.73,15 "
        />
    </svg>
);

Close.propTypes = propTypes;
Close.defaultProps = defaultProps;

export default Close;
